import { render, staticRenderFns } from "./OrderReasonHighlighter.vue?vue&type=template&id=2ca586d2"
import script from "./OrderReasonHighlighter.vue?vue&type=script&lang=js"
export * from "./OrderReasonHighlighter.vue?vue&type=script&lang=js"
import style0 from "./OrderReasonHighlighter.vue?vue&type=style&index=0&id=2ca586d2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports